import { NgModule } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BrowserModule, BrowserTransferStateModule } from '@angular/platform-browser';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { FooterModule } from './shared/components';
import { AuthService, ScreenService, AppInfoService, AuthGuardService } from './shared/services';
import { AppRoutingModule } from './app-routing.module';
import { DxButtonModule, DxDataGridModule, DxDateBoxModule, DxFileUploaderModule, DxLoadPanelModule, DxNumberBoxModule, DxRadioGroupModule, DxSelectBoxModule, DxTextAreaModule, DxTextBoxModule } from 'devextreme-angular';
import { MatCardModule } from '@angular/material/card';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { LoaderInterceptor } from './shared/services/loader-interceptor';
import { TokenInterceptor } from './shared/services/token.interceptor';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { SurveyLayoutComponent } from './layouts/survey-layout/survey-layout.component';
import { ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    AppComponent,
    SurveyLayoutComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FooterModule,
    MatCardModule,
    DxTextBoxModule,
    FlexLayoutModule,
    MatExpansionModule,
    MatIconModule,
    MatGridListModule,
    MatDialogModule,
    MatSnackBarModule,
    DxLoadPanelModule,
    MatButtonModule,
    DxRadioGroupModule,
    MatSidenavModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    MatListModule,
    RouterModule.forRoot([]),
    DxSelectBoxModule,
    DxNumberBoxModule,
    DxDateBoxModule,
    DxButtonModule,
    DxDataGridModule,
    AppRoutingModule,
    DxFileUploaderModule,
    MatInputModule,
    MatIconModule,
    NgxExtendedPdfViewerModule,
    DxTextAreaModule,
    ReactiveFormsModule,
    BrowserTransferStateModule
  ],
  providers: [
    AuthService,
    AuthGuardService,
    ScreenService,
    AppInfoService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
  ],
  entryComponents: [

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
